/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { getDataDeletionRequests } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { format } from "date-fns";
import { TextField, Box, MenuItem } from "@mui/material";

const DeleteRequests = () => {
  const { state } = useAuth();
  const [workers, setWorkers] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState<number | null>(0);

  const fetchPendingUpdates = async () => {
    try {
      setLoading(true);
      const response: any = await getDataDeletionRequests(state.user?.token, statusFilter);
      setWorkers(response.data.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingUpdates();
  }, [statusFilter]);

  const columns: any[] = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Full Name",
      flex: 1,
      renderCell: (params: any) => (
        <div>
          {params.row.user.name} {params.row.user.surname}
        </div>
      ),
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) => <div>{params.row.user.email}</div>,
    },
    {
      field: "requestedAt",
      headerName: "Requested At",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params: any) =>
        format(new Date(params.row.requestedAt || Date.now()), "dd/MM/yyyy"),
    },
    {
      field: "reason",
      headerName: "Reason",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
  ];

  return (
    <>
      <div className="form-content" style={{ justifyContent: "flex-end", marginRight: 240 }}>
        <TextField
          select
          label="Status"
          fullWidth
          size="small"
          value={statusFilter === null ? "" : statusFilter}
          onChange={(e) => setStatusFilter(e.target.value === "" ? null : Number(e.target.value))}
          style={{margin: 10, width: "20%"}}
        >
          <MenuItem value={0}>
            Pending
          </MenuItem>
          <MenuItem value={1}>
            Requests
          </MenuItem>
          <MenuItem value={2}>
            Completed
          </MenuItem>
          <MenuItem value={3}>
            Cancelled
          </MenuItem>
        </TextField>
      </div>

      <Box sx={{ height: 785, width: "70%", margin: "0 auto" }}>
        <DataGrid
          rows={workers}
          columns={columns}
          loading={loading}
          disableRowSelectionOnClick
          pageSizeOptions={[100]}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 100 },
            },
          }}
          sx={{
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              fontSize: 15,
            },
            "& .MuiDataGrid-columnHeader": {
              backgroundColor: "#f0f0f0",
              fontWeight: "bold",
            },
            cursor: "pointer",
          }}
        />
      </Box>
    </>
  );
};

export default DeleteRequests;
